export default {
	metaInfo: {
		title: 'Privacy Policy – ImmerseFX'
	}
}
